import { InputCurrency } from "components/individual/inputs/Inputs";
import { mnCurrency } from "helpers/money";
import React from "react";
import { useState } from "react";
import { Label } from "structure/Document";

/**
 * Render P.U. input
 * @param {object} props - Props
 * @param {number?} props.value - Default pu for the input
 * @param {(number)=>void} props.onChange - Value when input changes
 * @param {number?} props.maxLength - Max number of CHARACTERS allowed to type
 * @param {boolean?} props.informative - True if the component is on overview mode
 * @param {import("../../types").typeDocument} props.typeDocument - Type of document
 * @returns {JSX.Element}
 */
export default function PU({
  onChange = () => {},
  value = 0,
  maxLength = 10,
  informative = false,
  typeDocument = "cotizacion",
}) {
  const [val, setVal] = useState(value);

  const handleChange = (amount) => {
    onChange(amount);
    setVal(amount);
  };

  return (
    <>
      <Label required={val <= 0}>Precio venta</Label>
      {informative && typeDocument === "odc" ? (
        <p className="m-0">{mnCurrency(value)}</p>
      ) : (
        <InputCurrency
          labelTxt=""
          defaultValue={value}
          placeholder="Escribe aquí"
          onChange={handleChange}
          maxLength={maxLength}
        />
      )}
    </>
  );
}
